<template>
  <div class="container" :style="pageStyle">
    <div  v-for='(editablePageConfig,key) in editablePageConfigList' :key="key">
      <model1 v-if='editablePageConfig.editable_page_model_id==1' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model1>
      <model2 v-if='editablePageConfig.editable_page_model_id==2' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model2>
      <model6 v-if='editablePageConfig.editable_page_model_id==6' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model6>
      <model12 v-if='editablePageConfig.editable_page_model_id==12' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model12>
      <model13 v-if='editablePageConfig.editable_page_model_id==13' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model13>
      <model14 v-if='editablePageConfig.editable_page_model_id==14' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model14>
      <model15 v-if='editablePageConfig.editable_page_model_id==15' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model15>
      <model16 v-if='editablePageConfig.editable_page_model_id==16' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model16>
      <model17 v-if='editablePageConfig.editable_page_model_id==17' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model17>
      <model18 v-if='editablePageConfig.editable_page_model_id==18' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model18>
      <model19 v-if='editablePageConfig.editable_page_model_id==19' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model19>
      <model20 v-if='editablePageConfig.editable_page_model_id==20' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model20>
      <model21 v-if='editablePageConfig.editable_page_model_id==21' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model21>
      <model22 v-if='editablePageConfig.editable_page_model_id==22' v-bind:editablePageConfig="editablePageConfig" v-bind:editablePage="editablePage"></model22>
    </div>
	<mt-popup v-model="isshow" :closeOnClickModal="false" style="width:100%">
	  <div class="jump-adv">
		  <img class="jump-adv-image" :src="showimage">
		  <div class="jump-adv-button iconfont" @click="closeAdv()">&#xe65a;</div>
	  </div>
	</mt-popup>
	<div v-if="editablePage && editablePage.editable_page_theme_config && editablePage['editable_page_theme_config']['if_show_button']==1" class="float-button" :style="floatButtonStyle"><img :src="editablePage.editable_page_theme_config.button_image" /></div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import HomeCommonSearch from '../common/HomeCommonSearch'
import { getEditablePageConfigList } from '../../../api/homeindex'
import Model1 from './editable_page_model/Model1'
import Model2 from './editable_page_model/Model2'
import Model6 from './editable_page_model/Model6'
import Model12 from './editable_page_model/Model12'
import Model13 from './editable_page_model/Model13'
import Model14 from './editable_page_model/Model14'
import Model15 from './editable_page_model/Model15'
import Model16 from './editable_page_model/Model16'
import Model17 from './editable_page_model/Model17'
import Model18 from './editable_page_model/Model18'
import Model19 from './editable_page_model/Model19'
import Model20 from './editable_page_model/Model20'
import Model21 from './editable_page_model/Model21'
import Model22 from './editable_page_model/Model22'
export default {
  name:'SpecialIndex',
  data () {
    return {
		floatButtonStyle:{},
		showimage:'',
		isshow:false,
		pageStyle:{},
      editablePage:{},
      editablePageConfigList: []
    }
  },
  props:['pagePath','itemId'],
  components: {
    HomeCommonSearch,
    Model1,
    Model2,
    Model6,
    Model12,
    Model13,
    Model14,
    Model15,
    Model16,
    Model17,
    Model18,
    Model19,
    Model20,
    Model21,
    Model22
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      closePopupAdv: state => state.home.closePopupAdv,
    }),

  },
  mounted () {
  },
  created: function () {
	  
    var special_id = this.$route.query.special_id
    if (!special_id && !this.pagePath) {
      Toast('缺少参数')
      return
    }
    getEditablePageConfigList(special_id,this.pagePath,this.itemId).then(res => {

      this.editablePage = res.result.editable_page
      this.editablePageConfigList = res.result.editable_page_config_list
	  
      if(this.pagePath){
        this.saveHomeSpecial({pagePath:this.pagePath,storeId:'',itemId:this.itemId,editablePage:this.editablePage,editablePageConfigList:this.editablePageConfigList})
      }
	  if(this.editablePage){
		  this.pageStyle={backgroundColor:this.editablePage.editable_page_theme_config.back_color,paddingLeft: this.editablePage.editable_page_theme_config.page_margin+'px',paddingRight: this.editablePage.editable_page_theme_config.page_margin+'px',paddingBottom: (this.editablePage['editable_page_theme_config']['if_show_footer']==1?60:0)+'px', backgroundImage: 'url('+this.editablePage.editable_page_theme_config.back_image+')'}
		  this.saveShowSpecialFooter({showSpecialFooter:this.editablePage.editable_page_theme_config.if_show_footer})
		  document.title=this.editablePage.editable_page_name
		  if(this.editablePage.editable_page_theme_config.if_show_jump==1 && this.editablePage.editable_page_theme_config.jump_image){
			  this.showimage=this.editablePage.editable_page_theme_config.jump_image
			  if(!this.closePopupAdv){
				  this.isshow=true
			  }
		  }
		  var inset
		  switch(this.editablePage.editable_page_theme_config.button_position){
			  case '1':
				inset=this.editablePage.editable_page_theme_config.button_margin+'px auto auto 0px'
				break
			  case '2':	
				inset=this.editablePage.editable_page_theme_config.button_margin+'px 0px auto auto'
				break
			  case '3':	
				inset='auto auto '+this.editablePage.editable_page_theme_config.button_margin+'px 0px'
				break
			  case '4':	
				inset='auto 0px '+this.editablePage.editable_page_theme_config.button_margin+'px auto'
				break
		  }
		  this.floatButtonStyle={
			  inset:inset,
			  paddingLeft: this.editablePage.editable_page_theme_config.page_margin+'px',
			  paddingRight: this.editablePage.editable_page_theme_config.page_margin+'px'
			  }
	  }else{
		  this.saveShowSpecialFooter({showSpecialFooter:1})
	  }
	  
    }).catch(function (error) {
      Toast(error.message)
    })
  },

  methods: {
    ...mapMutations({
      saveHomeSpecial: 'saveHomeSpecial',
	  saveShowSpecialFooter:'saveShowSpecialFooter',
	  saveClosePopupAdv:'saveClosePopupAdv'
    }),
	closeAdv(){
		this.isshow=false
		this.saveClosePopupAdv({closePopupAdv:true})
	}
  }
}
</script>

<style scoped lang="scss">
.container{
	background-repeat: no-repeat;
	background-size: 100%;
}
.jump-adv{
	position: relative;
}
.jump-adv-image{
	max-width: 100%;
}
.jump-adv-button{
	position:absolute;
	top:0;
	right:0;
	width:20px;
	height: 20px;
	line-height: 20px;
	border-radius: 20px;
	text-align: center;
	background-color: rgba(255,255,255,.5);
	cursor: pointer;
}
.float-button{
	position:fixed;
	z-index: 2;
}
.float-button img{
	width: 40px;
	height: 40px;
}
</style>
